var PracticePoolCompletionInfo = (function(){
  var $mainContainer;
  var $gaugeContainer;
  var $defaultBtnLink;

  var _fetchElements = function() {
    $mainContainer  = $('.practice-pool-completion-info');
    $gaugeContainer = $mainContainer.find('.js-with-gauge');
    $defaultBtnLink = $mainContainer.find('.js-default-focus');
  };

  var _initGauge = function() {
    if($gaugeContainer.length) {
      new StreakGauge(
        $($gaugeContainer)
      ).setAnimated();
    }
  };

  // By default if the user clicks enter it should go to the continue pratice page
  var _setDefaultClickBehaviour = function() {
    enter_key_code = '13';

    // make visually obvious that this button is the default behaviour
    $defaultBtnLink.focus();

    $(document).keypress(function(e) {
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if (keycode == enter_key_code) {
          $defaultBtnLink[0].click();
        }
    });
  };

  var init = function(){
    _fetchElements();

    if ($mainContainer.length) {
      _initGauge();
      _setDefaultClickBehaviour();
    }
  };

  return {
    init: init
  }
}());

$(document).ready(function() {
  PracticePoolCompletionInfo.init();
});
